import hooks from '../../../hooks'
import { useQuery } from 'react-query'
import { get } from 'lodash'

const useAvailableLink = () => {
    const { api, endpoints } = hooks.useApi()
    const cacheKeys = hooks.useCacheKeys()
    const { data, isLoading } = useQuery(
        cacheKeys.MOBILE_ANROID_LINK,
        () => api.get(endpoints.mobileAndroidLink)
    )
    return {
        url: get(data, 'url'),
        isLoading
    }
}

export default useAvailableLink

